import { Button, IconPlus } from "@studyplus/boron-ui";
import { PaidServiceLabel } from "../../../../components/features/PaidServiceLabel";
import { PaidService, toJapanese } from "../../../../domains/PaidService";
import styles from "./PaidServiceSettingsButton.scss";

type Props = {
  paidServices: PaidService[];
  onClick: () => void;
};

export const PaidServiceSettingsButton = ({ paidServices, onClick }: Props) => {
  return (
    <div className="flex items-center gap-[1.6rem]">
      <Button
        variant="outline"
        size="xs"
        onClick={onClick}
        className={styles.button}
      >
        <IconPlus className="block h-[1.8rem] w-[1.8rem] align-middle" />
        <p>設定</p>
      </Button>
      <div className="flex flex-wrap gap-[0.8rem]">
        {paidServices.map((service) => (
          <PaidServiceLabel key={service.id}>
            {toJapanese(service.name)}
          </PaidServiceLabel>
        ))}
      </div>
    </div>
  );
};
